import cx from 'classnames';
import { ButtonLink, Card, Text } from '../../common/components';
import routes from '../../common/constants/routes';
import { t } from '../../common/i18n';
import { formatDate } from '../../common/utils/Date/Date';

interface SubscriptionCardProps {
  type: 'error' | 'warning' | 'success';
  title: string;
  subtitle?: string;
  expirationDate?: string;
  unusedVotes?: number;
  className?: string;
  /** Nezaplacená objednávka — místo „Objednat/Prodloužit" vede tlačítko na její stav. */
  openOrder?: { id: string; proformaNumber?: string | null } | null;
}

export const SubscriptionCard: React.FC<SubscriptionCardProps> = (props) => {
  const { type, title, subtitle, expirationDate, unusedVotes, className, openOrder } = props;

  const getCardStyles = () => {
    switch (type) {
      case 'error':
        return 'SubscriptionCard--error';
      case 'warning':
        return 'SubscriptionCard--warning';
      case 'success':
        return 'SubscriptionCard--success';
      default:
        return '';
    }
  };

  const buttonTitle = () => {
    if (openOrder) return t('Building.Subscription.showOrder');
    return type === 'success' ? t('Building.Subscription.extend') : t('Building.Subscription.order');
  };

  return (
    <Card className={cx('Card--content SubscriptionCard', getCardStyles(), className)}>
      <div className="Flex FlexAlign--center FlexJustify--space-between">
        <div className="SubscriptionCard__content">
          <Text size="body-medium" weight="600" className="SubscriptionCard__title">
            {title}
          </Text>
          {subtitle && (
            <Text size="body-small" weight="400" className="SubscriptionCard__subtitle  mt-1">
              {subtitle}
            </Text>
          )}
          {expirationDate && (
            <Text size="body-small" weight="400" className="SubscriptionCard__subtitle">
              {t('Building.Subscription.expirationDate')} {formatDate(expirationDate)}
            </Text>
          )}
          {unusedVotes !== undefined && (
            <Text size="body-small" weight="400" className="SubscriptionCard__subtitle">
              {unusedVotes} {t('Building.Subscription.unusedVotes')}
            </Text>
          )}
          {openOrder && (
            <Text size="body-small" weight="400" className="SubscriptionCard__subtitle">
              {openOrder.proformaNumber
                ? t('Building.Subscription.pendingNumber', undefined, { number: openOrder.proformaNumber })
                : t('Building.Subscription.pending')}
            </Text>
          )}
        </div>
        <div className="SubscriptionCard__button">
          <ButtonLink
            to={openOrder ? `${routes.subscriptionOrder}order/${openOrder.id}` : routes.subscriptionOrder}
            title={buttonTitle()}
            size="small"
            variant="secondary-outline"
          />
        </div>
      </div>
    </Card>
  );
};
